module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Port-Acu.45d10dec.jpg";